import React, {useEffect} from "react"
import {useMessage, useModal, useLocal} from "../../AppContext"
import {useShareSolution} from "../../Hooks/ShareSolution"
import {InputEmail, InputRadio, InputText} from "../../Components/Input"
import {Button} from "../../Components/Button"
import {iconMail} from "../../Helper/Icons"
import style from "./Share.css"

export const Share = ({planningCode, planningName}) => {
    const local = useLocal()
    const message = useMessage()
    const share = useShareSolution(planningCode, planningName)
    const modal = useModal()

    useEffect(() => {
        share.setRoomName(planningName)
    }, [planningName])

    const openShare = (event) => {
        if (event.detail.consult === true) {
            share.setConsultation()
        }
    }

    useEffect(() => {
        document.addEventListener("solutionShare", openShare);
        return () => {
            document.removeEventListener("solutionShare", openShare);
        }
    }, [])

    const roomName = (event) => {
        share.setRoomName(event.target.value)
    }

    const email = (event) => {
        share.setEmail(event.target.value)
    }

    const name = (event) => {
        share.setName(event.target.value)
    }

    const phone = (event) => {
        share.setPhone(event.target.value)
    }

    const send = async () => {
        try {
            await share.submit()
            share.reset()
            message.showSuccess(local.__("Raumcode wurden versendet."))
        } catch (error) {
            message.showError(local.__(error.message))
        }
    }

    const privacy = () => {
        modal.openPrivacy()
    }

    return <div className={style.share}>
        {planningName}
        <div className={style.cta}>
            <div>{local.__("Möchten Sie den Raumcode per E-Mail erhalten oder Teilen?")}</div>
            <div>{local.__("Optional")}</div>
        </div>
        <div className={style.form}>
            <InputText onChange={roomName} value={share.getRoomName()} placeholder={local.__("Raumname (Optional)")}/>
            <InputEmail onChange={email} value={share.getEmail()} placeholder={local.__("E-Mail Adresse*")}/>
            <InputRadio onClick={share.toggleConsultation} isActive={share.isConsultation()}>
                <div style={{marginTop: "-3px"}}>{local.__("Kostenlose professionelle Beratung zu meinem Raum")}<sup>1</sup></div>
            </InputRadio>
            {share.isConsultation() && <>
                <InputText onChange={name} value={share.getName()} placeholder={local.__("Ihr Name *")}/>
                <InputText onChange={phone} value={share.getPhone()} placeholder={local.__("Ihre Telefonnummer *")}/>
            </>}
            <Button onClick={send} isDisabled={!share.isValid()}>{iconMail}{local.__("Raumcode senden")}</Button>
        </div>
        <div className={style.notes}>
            <div onClick={privacy} dangerouslySetInnerHTML={{__html: local.__('Mit dem Klick auf "Raumcode senden" akzeptieren Sie unsere <a>Datenschutzbestimmungen</a>')}}/>
            <div><sup>1</sup> {local.__('Wir werden in 1-2 Werktagen (Mo-Fr) per E-Mail Kontakt aufnehmen')}</div>
            <div>{local.__("* Pflichtfelder")}</div>
        </div>
    </div>
}
